<script>
import Swiper from 'swiper';
export default {
    data() {
        return {
            swiper: null,
        };
    },
    mounted() {
        this.swiper = new Swiper('.ph-mobile-swiper-container', {
            slidesPerView: 1,
            keyboard: true,
            loop: true,
            spaceBetween: 20,
            autoHeight: true,
            calculateHeight:true,
            pagination: {
                el: '.ph-mobile-swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.ph-mobile-swiper-button-next',
                prevEl: '.ph-mobile-swiper-button-prev'
            },
        });
    }
};
</script>
<style lang="less">
.ph-slider {
    .ph-mobile-swiper-pagination {
        margin-top: 0px;
    }
    .comment-content {
        font-size: 15px;
    }
    h2 {
        @media (max-width: 768px) {
            margin-bottom: 30px !important;
        }
    }
    .swiper-image {
        align-items: center;
    }
    .swiper-pagination {
        cursor: pointer;
    }
    .swiper-image {
        color: #fff;
        text-align: left;
        h3 {
            margin-bottom: 20px;
            color: #fff;
        }
    }
    .swiper-button-prev {
        left: -50px;
    }
    .swiper-button-next {
        right: -40px;
    }
    .swiper-button-prev .ic-arrow {
        color: #2795FF;
        border-radius: 50%;
        border: 1px solid #eee;
        width: 40px;
        height: 40px;
        font-size: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: rotate(180deg);
        background-color: #fff;
    }
    .swiper-button-next .ic-arrow {
        color: #2795FF;
        border-radius: 50%;
        border: 1px solid #eee;
        width: 40px;
        height: 40px;
        font-size: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fff;
    }
    .pre-formatted {
        white-space: pre-line;
        font-family: "Avenir Next Medium";
    }
    @media(min-width:990px){
        .home-organize-slider{
            display:block;
        }
        .organize-scroll {
            display:none;
        }
        .swiper-slide {
            width: 100%;
        }
    }
    @media(max-width:990px){
        .swiper-slide {
            width: 100%;
        }
        .arrows {
            display: none;
        }
    }
    .swiper-container {
        overflow: visible;
        @media (max-width: 768px) {
            overflow: hidden;
            margin-top: 30px !important;
        }
    }
    .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: transparent !important;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .organize-scroll{
        position:relative;
        width: 100%;
        overflow: auto;
        margin-top:40px;
    }
    .scroll-single{
        flex:none;
        margin-left: 40px;
    }
    .scroll-single .slide-title{
        display: flex;
        justify-content: center;
    }
    .swiper-image {
        opacity: 0.5;
        transition: 0.4s;
    }
    .swiper-slide-active .swiper-image {
        opacity: 1;
        border-radius: 17.14px;
    }
    .slider-title {
        color: #1f2243;
        font-size: 36px;
        line-height: 48px;
        text-align: center;
        margin-bottom: 30px;
        letter-spacing: 1px;
        font-family: "Avenir Next Medium"
    }
    .slide-title {
        font-weight: 600;
        font-size: 18px;
        line-height: 22px;
        padding: 10px;
        margin-bottom: 10px;
    }
    .organize .swiper-pagination-bullet:active,
    .organize .swiper-pagination-bullet-active:focus {
        outline:0;
    }
    .organize .swiper-pagination-bullet-active {
        background: #47BEFF;
    }
    .ph-mobile-swiper-pagination .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        margin-right: 12px;
        background: #47BEFF;
    }
    .swiper-container-horizontal
        > .swiper-pagination-bullets
        .swiper-pagination-bullet {
        margin: 0 10px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/frontend/components/PhMobileSlider.vue